import React from 'react';
import PropTypes from 'prop-types';
import AccountPoolHeaderButtons from '../AccountPoolHeaderButtons/AccountPoolHeaderButtons';
import AccountPoolsActionCreator from '../../../actions/AccountPoolsActionCreator';
import InternetBankingActions from '../../../actions/InternetBankingActions';
import StepHeader from '../../../includes/StepHeader';
import { Field } from 'web-ui-components/lib/molecules/forms';
import { ConfirmationModal } from 'web-ui-components/lib/organisms/modals';
import AccountPoolsStore from '../../../stores/AccountPoolsStore';
import LoaderComponent from '../../common/LoaderComponent';
import { AccountPoolDetailsTable } from '../AccountPoolDetailsTable/AccountPoolDetailsTable';
import { PoolDetails } from '../PoolDetails/PoolDetails';
import UserManagementStore from '../../../stores/UserManagementStore';
import AccountsActionCreator from '../../../actions/AccountsActionCreator/AccountsActionCreator';
import FavouritesActionCreator from '../../../actions/AccountsActionCreator/FavouritesActionCreator';
import AccountsStore from '../../../stores/AccountsStore/AccountsStore';

class GetPoolDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deletePoolConfirmationModal: false,
      isExpanded: false,
      poolDetails: null,
      accountDetails: null,
      accounts: AccountPoolsStore.getAllAccounts(),
    };
  }
  componentDidMount() {
    AccountPoolsActionCreator.getSpecificPoolDetails();
    AccountPoolsStore.addChangeListener(this.onChangeAccountPoolStore);
  }

  componentWillUnmount() {
    AccountPoolsStore.removeChangeListener(this.onChangeAccountPoolStore);
  }

  onChangeAccountPoolStore = () => {
    this.setState({
      poolDetails: AccountPoolsStore.getPoolDetails(),
    });
    if (AccountPoolsStore.accountDetailsLoadedFlag()) {
      InternetBankingActions.navigateToWebTask('WEB-ACCOUNT-DETAILS');
    }
  };

  deletePool = () => {
    this.setState({
      deletePoolConfirmationModal: true,
    });
  };

  deleteAccountPoolConfirm = () => {
    this.setState({
      deletePoolConfirmationModal: false,
    });
    AccountPoolsActionCreator.deleteAccountPool();
  };
  editPool = () => {
    AccountPoolsActionCreator.setEditModeFlag();
    InternetBankingActions.navigateToWebTask('WEB-CREATE-POOL');
  };

  redirectToAccountDetail = (account) => {
    FavouritesActionCreator.addSelectedAccount(account);
    const { id } = account;
    AccountsActionCreator.setAccountID(id);
    FavouritesActionCreator.resetAccountDetailsLoadedFlag();
    AccountsStore.getAccountDetail(id).accountDetails === undefined &&
      AccountsActionCreator.getAccountDetails(id);
  };

  render() {
    const { deletePoolConfirmationModal, isExpanded, poolDetails, accounts } =
      this.state;
    const { content } = this.props;
    const {
      deletePoolModalTitle,
      dismissDeleteAccountPoolButton,
      confirmDeleteAccountPoolButton,
      deletePoolModalBody,
      poolDetailPanelText,
    } = content;
    return (
      <div className="page container">
        <div className="col-xs1-20">
          <StepHeader
            showheaderCrumbs
            onClick={() =>
              InternetBankingActions.navigateToWebTask('WEB-ACCOUNT-POOLS')
            }
            headerCrumbsMessage="Back"
            controlBack={this.back}
          />
          {poolDetails && poolDetails.accountCount > 0 ? (
            <Field>
              {UserManagementStore.isCorporateAdmin() && (
                <Field className="row u-margin-bottom-2">
                  <AccountPoolHeaderButtons
                    content={content}
                    deletePool={this.deletePool}
                    editPool={this.editPool}
                  />
                </Field>
              )}
              <Field>
                {deletePoolConfirmationModal && (
                  <ConfirmationModal
                    title={deletePoolModalTitle}
                    onConfirm={this.deleteAccountPoolConfirm}
                    isOpen={deletePoolConfirmationModal}
                    onClose={() =>
                      this.setState({ deletePoolConfirmationModal: false })
                    }
                    dismissButtonText={dismissDeleteAccountPoolButton}
                    confirmButtonText={confirmDeleteAccountPoolButton}
                  >
                    <p>{deletePoolModalBody}</p>
                  </ConfirmationModal>
                )}
              </Field>
              <div className="web-ui-components">
                <AccountPoolDetailsTable
                  allAccounts={accounts}
                  isExpanded={isExpanded}
                  poolDetails={poolDetails}
                  onMoreClick={() => this.setState({ isExpanded: !isExpanded })}
                  tableText={poolDetailPanelText}
                  redirectToAccountDetail={this.redirectToAccountDetail}
                />
              </div>
              <PoolDetails
                content={content}
                allAccounts={accounts}
                poolDetails={poolDetails}
              />
            </Field>
          ) : (
            <LoaderComponent type="large" />
          )}
        </div>
      </div>
    );
  }
}

GetPoolDetails.propTypes = {
  content: PropTypes.shape({
    content: PropTypes.string,
  }).isRequired,
};
export { GetPoolDetails };
